import { useEffect, useRef, useState } from 'react';

// If you update this logic, please also update the implementation in the
// `recommend-js` package.
export function useStatus(initialStatus) {
  const timerId = useRef(undefined);
  const [status, setStatus] = useState(initialStatus);
  useEffect(() => {
    if (status !== 'stalled' && timerId.current) {
      clearTimeout(timerId.current);
    }
    if (status === 'loading') {
      timerId.current = setTimeout(() => {
        setStatus('stalled');
      }, 300);
    }
  }, [status]);
  return {
    status,
    setStatus
  };
}